import { render, staticRenderFns } from "./SecondPage.vue?vue&type=template&id=0f7b5a98&"
import script from "./SecondPage.vue?vue&type=script&lang=js&"
export * from "./SecondPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports